import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { HowItWorks } from '../components/HowItWorks';
import { Services } from '../components/Services';
import { Retainers } from '../components/Retainers';
import { Team } from '../components/Team';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function LandingPage() {
  useEffect(() => {
    // Set page title
    document.title = 'The Sprint Studio - Sprint-sized creative & product work';
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Monthly retainers for founders. Four experts covering strategy, design, content, and automation. Delivered in days, not weeks.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Monthly retainers for founders. Four experts covering strategy, design, content, and automation. Delivered in days, not weeks.';
      document.head.appendChild(meta);
    }
    // Set Open Graph tags for social sharing
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'The Sprint Studio');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:title');
      meta.content = 'The Sprint Studio';
      document.head.appendChild(meta);
    }
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Monthly retainers for founders and startups. Delivered in days, not weeks.');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:description');
      meta.content = 'Monthly retainers for founders and startups. Delivered in days, not weeks.';
      document.head.appendChild(meta);
    }
    const ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType) {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:type');
      meta.content = 'website';
      document.head.appendChild(meta);
    }
    // Set Twitter Card tags
    const twitterCard = document.querySelector('meta[name="twitter:card"]');
    if (!twitterCard) {
      const meta = document.createElement('meta');
      meta.name = 'twitter:card';
      meta.content = 'summary_large_image';
      document.head.appendChild(meta);
    }
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', 'The Sprint Studio');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'twitter:title';
      meta.content = 'The Sprint Studio';
      document.head.appendChild(meta);
    }
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', 'Monthly retainers for founders and startups. Delivered in days, not weeks.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'twitter:description';
      meta.content = 'Monthly retainers for founders and startups. Delivered in days, not weeks.';
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="min-h-screen bg-paper text-ink selection:bg-terracotta/20" data-id="element-189">
      <Navigation data-id="element-190" />
      <main data-id="element-191">
        <Hero data-id="element-192" />
        <HowItWorks data-id="element-193" />
        <Services data-id="element-194" />
        <Retainers data-id="element-195" />
        <Team data-id="element-196" />
        <Contact data-id="element-197" />
      </main>
      <Footer data-id="element-198" />
    </div>;
}